// extracted by mini-css-extract-plugin
module.exports = {"metadataPackageTitle":"styles-module_metadataPackageTitle__2EEPlYiKVFTKd9n-8o6lys"};